<div class="bk-dialog bk-dialog__event">
	
	<button class="bk-modal__close_btn"
		(click)="close()"
		type="button">
		<mat-icon>close</mat-icon>
	</button>
    
    <h4 mat-dialog-title>
        {{ (eventId ? 'Edit' : 'Add') | translate }} {{'Fertilization Event' | translate }}
    </h4>

	<div mat-dialog-content>
      	<!--<div *ngIf="isLoaded === false" class="bk-loader__container">
            <div class="bk-loader">{{'Loading' | translate }}...</div>
        </div>-->
		<div style="display:flex">
			<!-- left side -->
			<ng-container *ngIf="isLoaded && form">
				<div [formGroup]="form" class="bk-form">
					<mat-form-field appearance="fill"
						class='mat-form-field--one-line mat-form-field--short'>
						<mat-label>{{ 'Event Date' | translate }}</mat-label>
						<input matInput [matDatepicker]="picker"
							[max]="maxDate"
							size="10"
							required
							formControlName="EventDate">
						<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
						<mat-datepicker #picker></mat-datepicker>
						<mat-error *ngIf="f.EventDate.invalid && (f.EventDate.dirty || f.EventDate.touched)">
							{{'Planting Event Date Error Text' | translate }}
						</mat-error>
					</mat-form-field>

					<mat-form-field appearance="fill"
						class="mat-form-field--one-line mat-form-field--short">
						<mat-label>
							{{'Fertilizer Type' | translate }}
						</mat-label>
						<mat-select formControlName="FertilizerId"
							required>
							<mat-option *ngFor="let fertilizer of fertilizers"
								[value]="fertilizer.Id">
								{{fertilizer.Name}}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="f.FertilizerId.invalid && (f.FertilizerId.dirty ||
							f.FertilizerId.touched)">
							{{'This field is required.' | translate }}
						</mat-error>
					</mat-form-field>

					<div class="bk-clearfix" style="margin-top:-22px; margin-bottom: 7px; font-size: 12px;
						float: right; position:relative; right: 17px;">
						<a *ngIf="f.FertilizerId.value > 0"
							href="javascript:void(0);"
							[popper]="fertilizerDetail"
							[popperTrigger]="'hover'"
							[popperTimeoutAfterShow]="5000">
							{{'Fertilizer Details' | translate }}
						</a>
					</div>

					<ng-container *ngIf="isFertilizationsPerMonth && isNDependent">
						<mat-form-field appearance="fill"
							class="mat-form-field--one-line mat-form-field--short">
							<mat-label>
								{{'Fertilizations Per Month' | translate }}
							</mat-label>
							<input matInput
								type="number"
								step="0.01"
								required
								name="FertilizationsPerMonth"
								formControlName="FertilizationsPerMonth"/>
							<mat-error *ngIf="f.FertilizationsPerMonth.invalid &&
								(f.FertilizationsPerMonth.dirty || f.FertilizationsPerMonth.touched)">
								{{'Fertilizations per Month must be a number between 1 and 10' | translate }}
							</mat-error>
						</mat-form-field>
					</ng-container>

					<ng-container *ngIf="!isFertilizationsPerMonth && isNDependent">
						<mat-form-field appearance="fill"
							class="mat-form-field--one-line mat-form-field--short">
							<mat-label>
								{{'Days To Next Fertilization' | translate }}
							</mat-label>
							<input matInput
								type="number"
								step="0.01"
								required
								name="DaysToNextFertilization"
								formControlName="DaysToNextFertilization"/>
							<mat-error *ngIf="f.DaysToNextFertilization.invalid &&
								(f.DaysToNextFertilization.dirty || f.DaysToNextFertilization.touched)">
								{{'Not a valid number' | translate }}
							</mat-error>
						</mat-form-field>
					</ng-container>

					<!-- Soil Sample Dropdown -->

					<ng-container *ngIf="!isTree && isNDependent">
						<!--
							trees use initial tissue samples for N calculation, so doesn't use soil samples
							alfalfa do not use N, so soil samples are not useful
						-->
						<mat-form-field appearance="fill"
							class="mat-form-field--one-line mat-form-field--short"
							hintLabel="{{ 'Choose the soil sample date used to calculate this recommendation' | translate }}">
							<mat-label>
								{{'Soil Sample' | translate }}
							</mat-label>
							<mat-select formControlName="soilSampleEventId"
								required>
								<mat-option [value]="-2">
									{{'No Soil Sample' | translate}}
								</mat-option> <!-- "null" is a string, not null -->
								<mat-option *ngFor="let sample of soilSamples"
									[value]="sample.Id">
									{{sample.Name}}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</ng-container>

					<button *ngIf="isNDependent && !shouldShowNContributionSummary"
						class="bk-button bk-button--medium"
						[disabled]="!f.IsFertilizerChemical.value"
						(click)="openNContributionDialog()">
						{{ 'Add' | translate }} N Contribution
                		<img class='bk-button__loader' *ngIf='isNContributionLoading' src='/assets/images/loader-20px.gif'/>
					</button>
					<div *ngIf="shouldShowNContributionSummary"
						class="cm-event-dialog__n-contribution-summary">
						<div class="cm-event-dialog__n-contribution-summary__label">
							{{ 'N Contribution From Water' | translate }}
						</div>
						<div class="cm-event-dialog__n-contribution-summary__row">
							<div class="cm-event-dialog__n-contribution-summary__value">
								<span class="cm-event-dialog__n-contribution-summary__amount">
									{{ f.NAppliedFromWater.value | number: '1.0-2' }}
								</span>
								<span class="cm-event-dialog__n-contribution-summary__unit">
									lbs N/{{ 'acre' | translate }}
								</span>
							</div>
							<div class="cm-event-dialog__n-contribution-summary__actions">
								<a (click)="openNContributionDialog()">
									{{ 'Edit' | translate }}
								</a>
								<span>|</span>
								<a (click)="clearNContribution()">
									{{ 'Clear' | translate }}
								</a>
							</div>
						</div>
					</div>
					<span *ngIf='lastUpdated'
						style="width: 225px;"
						class='bk-modal__last-updated-meta bk-clearfix'>
						{{ 'Last updated by' | translate }} {{lastUpdated}}
					</span>
				</div>
			</ng-container>

			<!-- right side -->
			<div class="right-side" 
				style="max-width: 733px; position: relative;">

				<div *ngIf="isLoaded && f.IsFertilizerChemical.value"
					class="cm-event-dialog__unit-toggle">
					<div class="bk-button-set bk-button-set--right
						bk-event__button-set">
						<button class="bk-button bk-button-set__button
							bk-button-set__button--on-green
							bk-unit-menu__button bk-button--gray-icon
							bk-event__button-set__button"
							type="button"
							[ngClass]="{'bk-button-set__button--selected':
								units === nUnits.LB_PER_ACRE}"
							(click)="toggleToLbsNPerAcre()">
							{{'lbs' | translate }} N/{{'acre' | translate }}
						</button>

						<button class="bk-button bk-button-set__button
							bk-button-set__button--on-green
							bk-unit-menu__button bk-button--gray-icon
							bk-event__button-set__button"
							type="button"
							[ngClass]="{'bk-button-set__button--selected':
								units == nUnits.FERTILIZER}"
							(click)="toggleToFertUnits()">
							{{'Fertilizer Unit' | translate }}
						</button>
					</div>
				</div>

				<mat-tab-group
					class="cm-mat-tab-custom"
					style="max-height: 370px;"
					(selectedTabChange)="redrawGraph($event);">
					<mat-tab label="N Balance">
						<div *ngIf="!isChartLoaded" style="min-height: 320px;
							display: flex; justify-content: center; align-items: center;">
							<mat-spinner></mat-spinner>
						</div>
						<div [style.display]="isChartLoaded ? 'block' : 'none'"
							class="bk-chart" #chartContainer></div>
					</mat-tab>
					<mat-tab label="Applied VS Recommend">
						<div class="bk-chart" #appliedChartContainer></div>
					</mat-tab>
					<mat-tab label="Mineralization" *ngIf="f && !f.IsFertilizerChemical.value
						&& !f.IsFertilizerPrivate.value">
						<div class="bk-chart" #mineralizationChartContainer></div>
					</mat-tab>
				</mat-tab-group>

				<div *ngIf='warnings.indexOf(warningTypes.ZERO_LBS_PER_GALLON) > -1 ||
                    warnings.indexOf(warningTypes.NO_YIELD) > -1 ||
                    warnings.indexOf(warningTypes.CUSTOM_ORGANIC_RECORD_KEEPING_ONLY) > -1 ||
                    hasEstimatedNApplied'
					class="bk-modal__warning-section bk-clearfix"
					style="width: 100%;"
					[ngClass]="{ 'bk-model__warning-section--remove-margin' : !eventId}">
					<div *ngIf="warnings.indexOf(warningTypes.CUSTOM_ORGANIC_RECORD_KEEPING_ONLY) > -1
						|| hasEstimatedNApplied"
						class="bk-modal__warning-section__subsection cm-event-dialog__warning-subsection">
						<mat-icon class="cm-event-dialog__warning-icon">warning</mat-icon>

						<div>
							<ng-container
								*ngIf="warnings.indexOf(warningTypes.CUSTOM_ORGANIC_RECORD_KEEPING_ONLY) > -1">
								{{ 'CropManage does not calculate nitrogen recommendations or mineralization'
								+ ' curves for custom organic fertilizers.' | translate }}
							</ng-container>

							<ng-container *ngIf="hasEstimatedNApplied">
								{{ 'Estimated N applied for custom organic fertilizers is calculated using'
								+ ' Total N%.' | translate }}
							</ng-container>
						</div>
					</div>
					<div *ngIf="warnings.indexOf(warningTypes.NO_YIELD) > -1"
						class="bk-modal__warning-section__subsection cm-event-dialog__warning-subsection">
						<mat-icon class="cm-event-dialog__warning-icon">warning</mat-icon>
						<div>{{ 'Missing yield warning' | translate }}</div>
					</div>
					<div *ngIf="warnings.indexOf(warningTypes.ZERO_LBS_PER_GALLON) > -1"
						class="bk-modal__warning-section__subsection cm-event-dialog__warning-subsection">
						<mat-icon class="cm-event-dialog__warning-icon">warning</mat-icon>
						<div>
							{{ 'If Lbs Per Gallon for a wet fertilizer is zero, CropManage will not be able'
							+ ' to convert lbs N/acre to lbs/gallon. You can correct this in Ranch Settings.'
							| translate }}
						</div>
					</div>
				</div>

				<!-- recommendation section -->
				<div *ngIf="isLoaded" style="width: 733px; display: flex; gap: 25px; justify-content: space-between;
					border: 2px solid gray;border-radius: 5px; padding: 16px;">
					<div>
						<h4 style="margin-top: 14px; margin-bottom: 0px;">Recommendation</h4>
						<ng-container *ngIf="f.NPercentage.value === 0 || (form && form.invalid)">
							<div class="bk-modal__recommendation">
								{{ 'N/A' | translate }}<mat-icon *ngIf="f.NPercentage.value === 0"
								class="bk-info-icon bk-info-icon__irrigation-recommendation"
								matTooltip="{{ 'Fertilizer type has no nitrogen.' }}">
								help_outline
							</mat-icon>
							</div>
						</ng-container>

						<ng-container *ngIf="f.NPercentage.value > 0 && form && form.valid">
							<ng-container *ngIf="units === nUnits.FERTILIZER">
								<div class="bk-modal__recommendation">
									{{FertilizationRecommendationLbsPerAcre | number: '1.2-2'}} 
									<span *ngIf="f.IsFormulationTypeDry.value"
										class="bk-modal__recommendation--unit">
										{{'lbs' | translate }}/{{'acre' | translate }}
									</span>
									<span *ngIf="!f.IsFormulationTypeDry.value"
										class="bk-modal__recommendation--unit">
										{{'gal' | translate }}/{{'acre' | translate }}
									</span>
									<mat-icon class="bk-info-icon bk-info-icon__irrigation-recommendation"
										matTooltip="Click to see details"
										(click)="openRecommendationSummary()">
										open_in_new
									</mat-icon>
								</div>
							</ng-container>
							<ng-container *ngIf="units === nUnits.LB_PER_ACRE">
								<div class="bk-modal__recommendation">
									{{ NFertilizationRecommended | number: '1.2-2'}} 
									<span class="bk-modal__recommendation--unit">
										{{'lbs' | translate }} N/{{'acre' | translate }}
									</span>
									<mat-icon class="bk-info-icon bk-info-icon__irrigation-recommendation"
										matTooltip="Click to see details"
										(click)="openRecommendationSummary()">
										open_in_new
									</mat-icon>
								</div>
							</ng-container>
						</ng-container>
					</div>

					<div [formGroup]="form" *ngIf="isLoaded && form">
						<ng-container *ngIf="!isNDependent">

							<!-- code is identical -->
							<mat-form-field appearance="fill"
								class="mat-form-field--short mat-form-field--two-wide__left">
								<mat-label>
									{{'Manager Amount' | translate }}
								</mat-label>
								<input matInput
									type="number"
									step="0.01"
									formControlName="ManagerFertilizerAmount"/>
								<span matSuffix>
									<span *ngIf="f.IsFormulationTypeDry.value"
										class="bk-modal__field-unit">
										{{'lbs' | translate }}/{{'acre' | translate }}
									</span>
									<span *ngIf="!f.IsFormulationTypeDry.value"
										class="bk-modal__field-unit">
										{{'gal' | translate }}/{{'acre' | translate }}
									</span>
								</span>
								<mat-hint align="start"><strong>{{ 'Enter the amount recommended by a manager' | translate }}</strong> </mat-hint>
								<mat-error *ngIf="f.ManagerFertilizerAmount.invalid &&
									(f.ManagerFertilizerAmount.dirty ||
									f.ManagerFertilizerAmount.touched)">
									{{'Not a valid number' | translate }}
								</mat-error>
							</mat-form-field>
							<mat-form-field appearance="fill" style="margin-left: 10px;"
								class="mat-form-field--short mat-form-field--two-wide__right">
								<mat-label>
									{{'Amount Applied' | translate}}
								</mat-label>
								<input matInput
									type="number"
									step="0.01"
									name="FertilizerApplied"
									formControlName="FertilizerApplied"/>
								<span matSuffix class="mat-form-field-suffix--padded">
									<ng-container *ngIf="f.IsFormulationTypeDry.value">
										{{'lbs' | translate }}/{{'acre' | translate }}
									</ng-container>
									<ng-container *ngIf="!f.IsFormulationTypeDry.value">
										{{'gal' | translate }}/{{'acre' | translate }}
									</ng-container>
								</span>
								<mat-hint align="start"><strong>{{ 'Enter the amount that was actually applied' | translate }}</strong> </mat-hint>
								<mat-error *ngIf="f.FertilizerApplied.invalid &&
									(f.FertilizerApplied.dirty ||
									f.FertilizerApplied.touched)"
									class="bk-invalid-text">

									{{'Not a valid number' | translate }}
								</mat-error>
							</mat-form-field>
						</ng-container>

						<div *ngIf="isNDependent">
							<ng-container *ngIf="units === nUnits.FERTILIZER">
								<mat-form-field appearance="fill"
									style="margin-right: 10px;"
									class="mat-form-field--short mat-form-field--two-wide__left">
									<mat-label>
										{{'Manager Amount' | translate }}
									</mat-label>
									<input matInput
										type="number"
										step="0.01"
										formControlName="ManagerFertilizerAmount"/>
									
									<span matSuffix *ngIf="f.IsFormulationTypeDry.value" 
										class="mat-form-field-suffix--padded">
										{{'lbs' | translate }}/{{'acre' | translate }}
									</span>
										
									<span matSuffix
										*ngIf="!f.IsFormulationTypeDry.value"
										class="mat-form-field-suffix--padded">
										{{'gal' | translate }}/{{'acre' | translate }}
									</span>
									
									<mat-hint align="start">{{ 'Enter the amount recommended by a manager' | translate }}</mat-hint>
									<mat-error *ngIf="f.ManagerFertilizerAmount.invalid &&
										(f.ManagerFertilizerAmount.dirty ||
										f.ManagerFertilizerAmount.touched)">

										{{'Not a valid number' | translate }}
									</mat-error>
								</mat-form-field>
							</ng-container>

							<ng-container *ngIf="units === nUnits.LB_PER_ACRE">
								<mat-form-field appearance="fill"
									style="margin-right: 10px;"
									class="mat-form-field--short mat-form-field--two-wide__left">
									<mat-label>
										{{'Manager Amount' | translate }}
									</mat-label>
									<input matInput
										type="number"
										step="0.01"
										formControlName="managerNRecommendation"/>
									<span matSuffix class="mat-form-field-suffix--padded">
										{{'lbs' | translate }} N/{{'acre' | translate }}
									</span>

									<mat-hint align="start">{{ 'Enter the amount recommended by a manager' | translate }}</mat-hint>
									<mat-error *ngIf="f.managerNRecommendation.invalid &&
										(f.managerNRecommendation.dirty ||
										f.managerNRecommendation.touched)"
										class="bk-invalid-text">
										{{'Not a valid number' | translate }}
									</mat-error>
								</mat-form-field>
							</ng-container>

							<ng-container *ngIf="units === nUnits.FERTILIZER">
								<mat-form-field appearance="fill"
									class="mat-form-field--short mat-form-field--two-wide__right">
									<mat-label>
										{{'Fertilizer Applied' | translate }}
									</mat-label>
									<input matInput
										type="number"
										step="0.01"
										name="FertilizerApplied"
										formControlName="FertilizerApplied"/>
									<span matSuffix class="mat-form-field-suffix--padded">
										<span *ngIf="f.IsFormulationTypeDry.value">
											{{'lbs' | translate }}/{{'acre' | translate }}
										</span>
										<span *ngIf="!f.IsFormulationTypeDry.value">
											{{'gal' | translate }}/{{'acre' | translate }}
										</span>
									</span>
									<mat-hint align="start">{{ 'Enter the amount that was actually applied' | translate }}</mat-hint>
									<mat-error *ngIf="f.FertilizerApplied.invalid &&
										(f.FertilizerApplied.dirty ||
										f.FertilizerApplied.touched)"
										class="bk-invalid-text">
							
										{{'Not a valid number' | translate }}
									</mat-error>
								</mat-form-field>
							</ng-container>
							<ng-container *ngIf="units === nUnits.LB_PER_ACRE">
								<mat-form-field appearance="fill"
									class="mat-form-field--short mat-form-field--two-wide__right">
									<mat-label>
										{{'Fertilizer N Applied' | translate}}
									</mat-label>
									<input matInput
										type="number"
										step="0.01"
										name="NApplied"
										formControlName="NApplied"/>
									<span matSuffix class="mat-form-field-suffix--padded">
										{{'lbs' | translate }} N/{{'acre' | translate }}
									</span>
									<mat-hint align="start">{{ 'Enter the amount that was actually applied' | translate }}</mat-hint>
									<mat-error *ngIf="f.NApplied.invalid &&
										(f.NApplied.dirty ||
										f.NApplied.touched)"
										class="bk-invalid-text">

										{{'Not a valid number' | translate }}
									</mat-error>
								</mat-form-field>
							</ng-container>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>

	<div mat-dialog-actions
        align="end">

		<button [disabled]="form && form.invalid"
			class="bk-button__delete"
			*ngIf="eventId"
			type="button"
			(click)="onDeleteConfirmationOpen($event)">

			{{'Delete' | translate }}
		</button>

		<button mat-button
			class="bk-button bk-button--medium bk-button--text-only"
			type="button"
			(click)="close()">

			{{'Cancel' | translate }}
		</button>

		<button mat-button
			[disabled]="form && form.invalid"
			class="bk-button bk-button--medium"
			*ngIf="!eventId"
			type="button"
			(click)="create()">

			{{(isSaving ? 'Creating' : 'Create') | translate }}
			<img class='bk-button__loader' *ngIf='isSaving' src='/assets/images/loader-20px.gif'/>
		</button>

		<button mat-button
			[disabled]="form && form.invalid"
			class="bk-button bk-button--medium"
			*ngIf="eventId"
			type="button"
			(click)="update()">

			{{(isSaving ? 'Saving' : 'Save') | translate }}
			<img class='bk-button__loader' *ngIf='isSaving' src='/assets/images/loader-20px.gif'/>
		</button>
    </div>
</div>

<popper-content #fertilizerDetail>
    <fertilizer-detail
        [form]="form">
    </fertilizer-detail>
</popper-content>
